export default __webpack_public_path__ + "img/41c7f5fbf1e55677f65469d78e3cbd42.svg";